import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux'
import {Head, TicketConversation} from "../../components";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {ticketAction, treeAction} from "../../actions";
import {Box, Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import ReactPaginate from "react-paginate";
import moment from 'moment-jalaali'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import './ticket.css'
import Autocomplete from '@mui/lab/Autocomplete';
import { UserAutocomplete, TicketCreate, TicketChangeCategory, TicketChangeStatus} from './../../components'
import { DatePicker } from "zaman";
import MarketerLink from "../../components/Marketer/Name";

const Tickets = ( props ) => {

    const { fetchEntities, ticketReducer, treeCategory, treeReducer, authReducer } = props;


    const [page, setPage] = useState(1);
    const [sort_field, setSortField] = useState('id');
    const [sort_type, setSortType] = useState('desc');
    const [limit, setLimit] = useState(100);
    const [filter, setFilter] = useState({
        'title' : '',
        content: '',
        id: '',
        status: -1,
        from_date: '',
        to_date: '',
        user_id: '',
        parent_id: '',
        name: '',
        username: '',
        national_code: '',
        marketer_code: '',
        mobile: '',
    });

    const handleChangeSearchInput = (event) => {

        let search = filter;

        search[event.target.name] = event.target.value;

        setFilter({...search})

    }

    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        let search = filter;

        search[name] = value;

        setFilter({...search})

    }

    useEffect(() => {
        treeCategory()
    }, [])


    useEffect(() => {
        handleRequest();
    }, [sort_field, sort_type, limit, page, filter]);


    const handleRequest = () => {
        fetchEntities({
            filter,
            sort_field: sort_field,
            sort_type: sort_type,
            page: page,
            limit: limit
        })
    };


    const setSelectedDay = (value, name) => {
        let search = filter;
        filter[name] = value;
        setFilter({...search});
    };

    const pageCount = Math.ceil(parseInt(ticketReducer.entities?.total) / parseInt(ticketReducer.entities?.per_page));


    return(
        <div style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/', 'title': 'مدیریت تیکت ها', 'description': 'مشتریان را مدیریت کنید' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography >جستجو</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="عنوان"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='title'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="محتوا"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='content'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="شناسه"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete onChange={(value) => handleChangeSearchInputWithAutoComplete('created_by', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت"
                                    variant="outlined"
                                    value={filter.status}
                                    margin='dense'
                                    fullWidth
                                    name='status'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    {Object.keys(ticketReducer.status).map((item) => {
                                        return(
                                            <MenuItem key={1} value={item}>{ticketReducer.status[item]}</MenuItem>
                                        );
                                    })}

                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <Autocomplete
                                    onChange={((event, value) => handleChangeSearchInputWithAutoComplete('category_id', (value ? value.id : '') ))}
                                    options={treeReducer.nodes}
                                    getOptionLabel={(option) => option.title}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            fullWidth
                                            name='category_id'
                                            margin={"dense"}
                                            label="بخش"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete label={'بالاسری'} onChange={(value) => handleChangeSearchInputWithAutoComplete('parent_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="موبایل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='mobile'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="نام و نام خانوادگی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='name'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="نام کاربری"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='username'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="کد ملی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='national_code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type={"search"}
                                    id="outlined-name"
                                    label="کد بازاریابی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='marketer_code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <div className='datepicker-input-container'>
                                    <label>از تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            let n_filter = filter;
                                            n_filter["from_date"] = moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss');
                                            setFilter({...n_filter});
                                        }}
                                    />

                                </div>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <div className='datepicker-input-container'>
                                    <label>تا تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            let n_filter = filter;
                                            n_filter["to_date"] = moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss');
                                            setFilter({...n_filter});
                                        }}
                                    />

                                </div>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => setLimit(event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                {Boolean(authReducer.user.permissions.ticket.ticket_store.access) && <TicketCreate/>}
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                <div style={{ overflowX: 'auto'}}>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th onClick={() => {setSortField('id'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>#&nbsp;{ sort_field === 'id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('created_by'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>کاربر&nbsp;{sort_field === 'created_by' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('title'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>عنوان&nbsp;{sort_field === 'title' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('created_at'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>تاریخ ایجاد&nbsp;{sort_field === 'created_at' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('updated_at'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>به روز رسانی&nbsp;{sort_field === 'updated_at' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('category_id'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>بخش&nbsp;{sort_field === 'category_id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('status'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>وضعیت&nbsp;{sort_field === 'status' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                            {authReducer.user.permissions.ticket && authReducer.user.permissions.ticket.ticket_operator_report && Boolean(authReducer.user.permissions.ticket.ticket_operator_report.access) &&
                            <th onClick={() => {setSortField('creator_survey'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>نظرسنجی&nbsp;{sort_field === 'creator_survey' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>}
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {ticketReducer.entities.data && ticketReducer.entities.data.map((entity, index) => {
                            return(
                                <tr key={index}>
                                    <td>{entity.id}</td>
                                    <td><MarketerLink user={entity.created_by} /></td>
                                    <td>{entity.title}</td>
                                    <td style={{ direction: 'ltr'}}>{moment(entity.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                    <td style={{ direction: 'ltr'}}>{moment(entity.updated_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                    <td>
                                        <TicketChangeCategory reload={() => handleRequest()} entity={entity} />
                                    </td>
                                    <td>
                                        <TicketChangeStatus reload={() => handleRequest()} entity={entity} />
                                    </td>
                                    {authReducer.user.permissions.ticket && authReducer.user.permissions.ticket.ticket_operator_report && Boolean(authReducer.user.permissions.ticket.ticket_operator_report.access) && <td>{entity.creator_survey ? entity.creator_survey : '-'}</td>}
                                    <td>
                                        {Boolean(authReducer.user.permissions.ticket.ticket_conversations.access) && <TicketConversation ticket_id={entity.id} reload={() => handleRequest()} />}
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                />
            </>
        </div>

    );
}


const mapStateToProps = state => ({
    ticketReducer: state.ticketReducer,
    treeReducer: state.treeReducer,
    authReducer: state.authReducer

});

const mapDispatchToProps = (dispatch) => ({
    treeCategory: () => {
        dispatch(treeAction.ticketCategories())
    },
    fetchEntities: (object) => {
        dispatch(ticketAction.tickets(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Tickets)
